import { FormProvider, useForm } from "react-hook-form";


import { WizardProvider } from "../contexts/wizard";
import { useEventoContext } from "../contexts/eventos";
import { useEvento } from "@/store/evento/evento";

import { zodResolver } from '@hookform/resolvers/zod'
import { useMetaPixel } from "@/hooks/useMetaPixel";
import { useEffect } from "react";

import { CheckoutPayload, checkoutSchema } from "@/schemas/checkout.schema";

import { PaymentWizardContent } from "./wizard";

export const PaymentWizard = ({ onClose }: { onClose: () => void }) => {

    const { evento } = useEventoContext();
    const { state: entradas } = useEvento.use.entradas();
    const { state: funcion } = useEvento.use.funcion();

    const methods = useForm<CheckoutPayload>({
        resolver: zodResolver(checkoutSchema),
        defaultValues: {
            eventoId: evento.id,
            funcionId: funcion?.id,
            entradas,
            comprador: { nombre: "", email: "", telefono: "", tipoDocumento: "" as any, doc: "" },
            tarjeta: { nombre: "", numero: "", vencimiento: "", cvv: "", doc: "" },
            eventId: "",
        },
    });

    const { trackInitiateCheckout } = useMetaPixel();

    useEffect(() => {
        // Calcular total y cantidad de items
        const total = entradas.reduce((acc, e) => acc + (e.precio * e.cantidad), 0);
        const numItems = entradas.reduce((acc, e) => acc + e.cantidad, 0);
        const contentIds = entradas.map(e => String(e.tipoEntradaId));

        const eventId = trackInitiateCheckout({
            value: total,
            currency: 'ARS',
            numItems,
            contentIds
        });

        if (eventId) {
            methods.setValue('eventId', eventId);
        }
    }, [entradas, trackInitiateCheckout, methods]);

    return (
        <WizardProvider>
            <FormProvider {...methods}>
                <PaymentWizardContent onClose={onClose} methods={methods} />
            </FormProvider>
        </WizardProvider>
    );
};